import { jsonLdHtml } from "@/lib/seo";

/** schema.org structured data for search engines; rendered inline, never executed. */
export default function JsonLd({ data }: { data: object }) {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLdHtml(data) }} />;
}
